// extracted by mini-css-extract-plugin
module.exports = {"guide":"UseAndCareGuideView_guide__3DGKz","guide__heading":"UseAndCareGuideView_guide__heading__LXT9J","guide__body":"UseAndCareGuideView_guide__body__pWVMX"};